import { Component, OnInit } from '@angular/core';
import { unix } from 'moment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ContactHistoryReviewComponent } from '../contact-history-review/contact-history-review.component';
import { switchMap } from 'rxjs/operators';
import { UserService } from '../../../../../../core/auth/_services';
import { ActivatedRoute } from '@angular/router';
import { ContactsService } from '../../../../../../core/lists';
import { BehaviorSubject } from 'rxjs';
import { GeneralValidationMessagesService } from '../../../../../../core/services/general-validation-messages.service';

@Component({
  selector: 'kt-contact-hitory-tab',
  templateUrl: './contact-hitory-tab.component.html',
  styleUrls: ['./contact-hitory-tab.component.scss'],
})
export class ContactHitoryTabComponent implements OnInit {
  contact;
  loading$ = new BehaviorSubject(true);
  history = [];
  contactHistory = [];

  constructor(
    public dialog: MatDialog,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private contactService: ContactsService,
    private globalService: GeneralValidationMessagesService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if (params.id)
        this.globalService.getEntitiesById('contacts', params.id).subscribe((res) => {
          if (res) {
            this.contact = res.data;
            if (this.contact?.id) {
              this.loading$.next(true);
              this.getHistory();
            }
          }
        });
    });
  }

  getFormattedDate(timestamp) {
    return unix(timestamp / 1000).format('YYYY-MM-DD hh:mm a');
  }

  getHistoryText(record, contactHistory) {
    const hist = contactHistory.filter((history) => history.id === record.id);
    switch (true) {
      case record.rev_type === 'ADD':
        return record.first_name;
      case record.rev_type === 'MOD' || record.rev_type === 'DEL': {
        const idx = hist.indexOf(record);
        return idx < hist.length - 1 ? hist[idx + 1].first_name : '';
      }
      default:
        return '';
    }
  }

  openDialog(event, record) {
    event.stopPropagation();
    const idx = this.history.indexOf(record);
    const contactUpdateCondition =
      this.history.length > 1 && idx < this.history.length - 1 && record.rev_type === 'MOD';
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.autoFocus = false;
    dialogConfig.width = contactUpdateCondition ? '90vw' : '45vw';
    dialogConfig.data = contactUpdateCondition
      ? [
          { readonly: true, contact: this.history[idx] },
          { readonly: true, contact: this.history[idx + 1] },
        ]
      : [{ readonly: true, contact: this.history[idx] }];
    this.dialog.open(ContactHistoryReviewComponent, dialogConfig);
  }

  getHistory() {
    let history = [];
    let contactHistory = [];
    let users = [];
    this.activatedRoute.params.subscribe((params) => {
      const id = params.id;
      this.contactService
        .getHistoryByVersion(id)
        .pipe(
          switchMap((res) => {
            contactHistory = res.data;

            contactHistory.forEach((record) => users.push(record.username));
            users = [...new Set(users)];

            return this.userService.getUserByUserName(users);
          }),
        )
        .subscribe(
          (res) => {
            users = res.pageOfItems;
            history = [...contactHistory].sort((a, b) =>
              a.rev_timestamp > b.rev_timestamp ? -1 : 1,
            );
            history.forEach((record) => {
              const matchedUser = users.find((user) => user.userName === record.username);
              record.profileUrl = matchedUser ? matchedUser.profileUrl : '';
            });
            this.history = history;
            this.contactHistory = contactHistory;
            this.loading$.next(false);
          },
          () => {
            this.loading$.next(false);
          },
        );
    });
  }
}
